import { SignupComponent } from './pages/signup/signup.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'sign-up/:id',
    component: SignupComponent,
    pathMatch: 'prefix',
    children: [

    ]
  },

  {
    path: 'sign-up/:id/:leadId',
    component: SignupComponent,
    pathMatch: 'prefix',
    children: [

    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SignUpRoutingModule { }
